<template>
  <div class="my-level">
    <div class="level-bg-box">
      <div class="level-bg" :style="backgroundStyle(hostData.curGrade)"></div>
      <div class="level-box">
        <!-- 等级背景 -->
        <div class="level-text">{{ $t('lang.BaseCommon.k002') }}.{{ hostData.curGrade || 0 }}</div>
        <!-- 徽章 -->
        <div class="level-img" :style="{ 'background-image': `url(${badgeStyle(hostData.curGrade)})` }">{{ hostData.curGrade || 0 }}</div>
        <div class="progress-box">
          <div class="progress-level text">
            <span>{{ $t('lang.BaseCommon.k001') }}.{{ hostData.curWeekGrade }}({{ $t('lang.BaseCommon.k034') }})</span>
            <span>{{ $t('lang.BaseCommon.k001') }}.{{ 10 > hostData.curWeekGrade ? hostData.curWeekGrade + 1 : hostData.curWeekGrade }}</span>
          </div>
          <!-- 进度条 -->
          <div class="progress-line">
            <van-progress class="progress-bar" track-color="#ebebeb" :show-pivot="false" :percentage="percentageVal" stroke-width="11" />
          </div>

          <div class="progress-tips text">
            <span class="beans">
              {{ curGradeData.weekMinIncome > 0 ? curGradeData.weekMinIncome : 0 }}
              <img class="beans-img" :src="getMatchImg('beans')" alt="" />
            </span>
            <span class="beans-tip">
              {{ $t('lang.BaseCommon.k040') }}
              {{ nextGradeData.weekMinIncome - hostData.curWeekIncomeAmount > 0 ? nextGradeData.weekMinIncome - hostData.curWeekIncomeAmount : 0 }}
              <img class="beans-img" :src="getMatchImg('beans')" alt="" />
              <span class="get-bean">{{ $t('lang.BaseCommon.k049') }}</span>
            </span>
            <div class="beans">
              {{ 10 > hostData.curGrade ? nextGradeData.weekMinIncome : 0 }}
              <img class="beans-img" :src="getMatchImg('beans')" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="call-income" @click="openPrivateDia">
      <div class="title">{{ $t('lang.HostessCenter.k017') }}</div>
      <div class="income">
        <div class="income-num-img">
          {{ myPrivateCallIncome }}
          <img :src="getMatchImg('beans')" alt="" />
          /{{ $t('lang.BaseCommon.k045') }}
        </div>
        <van-icon class="edit" name="edit" />
      </div>
    </div>
    <div class="week-data">
      <div class="last-week week">
        <span>{{ $t('lang.BaseCommon.k002') }}.{{ hostData.lastWeekGrade }}</span>
        <span class="beans">
          {{ hostData.lastWeekIncomeAmount }}
          <img :src="getMatchImg('beans')" alt="" />
        </span>
        <span>{{ $t('lang.HostessCenter.k012') }}</span>
      </div>
      <span class="line"></span>
      <div class="this-week week">
        <span>{{ $t('lang.BaseCommon.k002') }}.{{ hostData.curWeekGrade }}</span>
        <span class="beans">
          {{ hostData.curWeekIncomeAmount }}
          <img :src="getMatchImg('beans')" alt="" />
        </span>
        <span>{{ $t('lang.BaseCommon.k034') }}</span>
      </div>
    </div>
    <div class="content">
      <div class="box-title">{{ $t('lang.BaseCommon.k047') }}</div>

      <!-- 等级选择 -->
      <div class="level-number" ref="scrollLevelList">
        <div
          v-for="(item, index) in hostData.levels"
          :key="item.grade"
          @click="handleLevel(index)"
          :class="stepCurLevel === item.grade ? 'active' : ''"
          :ref="'item' + index"
        >
          {{ $t('lang.BaseCommon.k002') }}.{{ item.grade }}
        </div>
      </div>
      <!-- 等级权益 -->
      <div class="level-right-box">
        <div class="level-right" v-for="(item, index) in stepPrivileges" :key="index">
          <div class="right-item">
            <!-- 需要有颜色的变化 -->
            <div class="right-img" :style="{ background: getPrivilegeColors(stepCurLevel, item) }">
              <img :src="item.icon | imgPath" alt="" />
            </div>
            <div class="right-text">
              <div class="tit">
                {{ item.title }}
              </div>
              <div class="con">
                {{ item.content }}
              </div>
            </div>
          </div>
          <div class="right-desc">
            <!-- prettier-ignore -->
            <div v-if="stepPrivilegesObj.grade >= map.get(String(item.privilegeType))">
              <div class="right-desc-val" v-if="item.privilegeType == 1">
                {{ stepPrivilegesObj.incomePerMinute }}<img class="icon" :src="getMatchImg('beans')" alt="" />/{{ $t('lang.BaseCommon.k045') }}
              </div>
              <div class="right-desc-val" v-if="item.privilegeType == 4">
                <img class="icon2" src="@/assets/packageAssets/views/P1_Girls/HostessCenter/default/iphone.png" alt="" />{{ stepPrivilegesObj.privateVideoMatchCount }}/{{ $t('lang.BaseCommon.k093') }}
              </div>
              <div class="right-desc-val" v-if="item.privilegeType == 6">
                {{ stepPrivilegesObj.videoPassIncomeAmount }}<img class="icon" :src="getMatchImg('beans')" alt="" />/{{ hostData.videoPassServerTimeSeconds }}s
              </div>
              <div class="right-desc-val" v-if="item.privilegeType == 8">
                <img class="icon2" src="@/assets/packageAssets/views/P1_Girls/HostessCenter/default/person.png" alt="" />{{ stepPrivilegesObj.msgLimitDay }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 规则 -->
      <div class="box-title">{{ $t('lang.BaseCommon.k044') }}</div>
      <div class="rule-tit">
        {{ $t('lang.HostessCenter.k009') }}
      </div>
      <table class="table-box">
        <tr class="header">
          <th>{{ $t('lang.BaseCommon.k043') }}</th>
          <th>{{ $t('lang.BaseCommon.k083') }}</th>
        </tr>
        <tr class="td-item" v-for="item in hostData.levels" :key="item.grade">
          <td>{{ $t('lang.BaseCommon.k002') }}.{{ item.grade }}</td>
          <td>
            {{ item.weekMinIncome > 0 ? item.weekMinIncome : 0 }}
            <img :src="getMatchImg('beans')" alt="" />
          </td>
        </tr>
      </table>
    </div>

    <!-- 选择 My Private Call income -->
    <Selete :defaultIndex="defaultIndex" :columns="gradeOptions" :showPop="showPri" @currentChoose="currentChoose" />
  </div>
</template>

<script>
import { apiFetchHostGradeInfo, apiFetchIncomeGradeList, apiFetchChoosePrivilege } from '@/api/imee'

import Selete from '@/components/CSelete/Selete.vue'

import levelBgOff from '@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_bg_off.png'
import levelBgOn from '@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_bg_on.png'

import levelOff from '@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_off.png'
import levelOn from '@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_on.png'

export default {
  components: { Selete },
  data() {
    return {
      hostData: {},
      stepCurLevel: 0,
      stepPrivileges: [],
      stepPrivilegesObj: {
        incomePerMinute: 0,
        matchCount: 0,
        payerPayAmount: 0,
        privateVideoMatchCount: 0,
        sendMsgToUserCount: 0,
        videoPassIncomeAmount: 0,
        weekMinIncome: 0,
      },

      // 背景图list
      levelBgList: {
        levelBgOff,
        levelBgOn,
      },
      // 徽章背景图list
      levelBadgeList: {
        1: levelOff,
        2: levelOn,
        3: levelOn,
        4: levelOn,
      },

      // 当前等级的数据
      curGradeData: {},
      // 下一等级的数据
      nextGradeData: {},

      // 每个特权首次满足条件时所在档的
      map: new Map(),

      gradeIncomeInfo: {},
      gradeOptions: [],
      myPrivateCallIncome: 0,

      // 显示第几张
      showBananaValue: 0,
      defaultIndex: 0,

      showPri: false,
      showImg: false,
    }
  },
  computed: {
    // 进度条值
    percentageVal() {
      if (this.curGradeData.grade == 10) {
        return 100
      }
      if (this.nextGradeData) {
        const a = this.hostData.curWeekIncomeAmount
        const b = this.nextGradeData.weekMinIncome
        return (a / b) * 100 > 0 ? (a / b) * 100 : 0
      }
      return 0
    },
  },
  methods: {
    // 等级背景图
    backgroundStyle(lv) {
      if (lv == 0) {
        return `background-image: url(${this.levelBgList['levelBgOff']}); background-color: transparent`
      }
      if (lv > 0) {
        return `background-image: url(${this.levelBgList['levelBgOn']}); background-color: transparent`
      }
    },
    // 等级徽章
    badgeStyle(lv) {
      if (lv == 0) {
        return this.levelBadgeList[1]
      }
      if (lv > 0 && lv <= 3) {
        return this.levelBadgeList[2]
      }
      if (lv > 3 && lv <= 6) {
        return this.levelBadgeList[3]
      }
      if (lv > 6 && lv <= 10) {
        return this.levelBadgeList[4]
      }
    },

    // 选择等级
    handleLevel(index) {
      const item = this.hostData.levels[index]
      this.stepCurLevel = item.grade
      this.stepPrivileges = item.levelPrivileges
      this.stepPrivilegesObj = { ...item }
    },
    closePri() {
      this.showImg = false
    },

    // 打开选择 My Private Call income
    openPrivateDia() {
      this.showPri = true
    },
    // 确定选择
    currentChoose(val) {
      if (this.gradeIncomeInfo.curGrade >= val.id) {
        this.fetchChoosePrivilege(val.id, val.text)
      }
      //
      else {
        const tips = this.$t('lang.HostessCenter.k001')
        this.$client.showToast(tips)
      }
    },
    closeSeletePop() {
      this.showPri = false
    },

    // 获取主播数据
    fetchHostGradeInfo() {
      this.$parent.checkTimeFlag()
      apiFetchHostGradeInfo()
        .then((res) => {
          if (!res) return

          this.map.clear()
          this.stepCurLevel = res.curGrade

          if (res.curWeekGrade === 10) {
            this.nextGradeData = {}
          }

          if (res.levels && res.levels.length > 0) {
            res.levels.forEach((item) => {
              // 各特权首次解锁的等级（存 grade，与模板 stepPrivilegesObj.grade 比较一致）
              if (item.incomePerMinute != null && item.incomePerMinute > 0) {
                if (!this.map.has('1')) this.map.set('1', item.grade)
              }
              if (item.sendMsgToUserCount != null && item.sendMsgToUserCount > 0) {
                if (!this.map.has('2')) this.map.set('2', item.grade)
              }
              if (item.matchCount != null && item.matchCount > 0) {
                if (!this.map.has('3')) this.map.set('3', item.grade)
              }
              if (item.privateVideoMatchCount != null && item.privateVideoMatchCount > 0) {
                if (!this.map.has('4')) this.map.set('4', item.grade)
              }
              if (item.payerPayAmount != null && item.payerPayAmount > 0) {
                if (!this.map.has('5')) this.map.set('5', item.grade)
              }
              if (item.videoPassIncomeAmount != null && item.videoPassIncomeAmount > 0) {
                if (!this.map.has('6')) this.map.set('6', item.grade)
              }
              if (item.scanTwitter === true || item.scanTwitter === 1) {
                if (!this.map.has('7')) this.map.set('7', item.grade)
              }
              if (item.msgLimitDay != null && item.msgLimitDay > 0) {
                if (!this.map.has('8')) this.map.set('8', item.grade)
              }

              item['levelPrivileges'] = res.privileges

              if (res.curWeekGrade == item.grade) {
                this.curGradeData = item
              }

              if (res.curWeekGrade + 1 == item.grade) {
                this.nextGradeData = item
              }
            })
          }

          this.hostData = res
          this.$emit('hostessData', this.hostData)

          this.$nextTick(() => {
            this.handleLevel(this.stepCurLevel)

            const scrollIdx = Array.isArray(res.levels) ? res.levels.findIndex((l) => l.grade === res.curGrade) : -1
            if (scrollIdx >= 0) {
              this.scrollToIndex(scrollIdx)
            }
          })
        })
        .catch(() => {})
    },

    // 滚动到指定位置 <取不到dom的话 这个方法会报错>
    scrollToIndex(index) {
      const element = this.$refs['item' + index]
      if (element && element.length) {
        element[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
      }
    },

    // 获取选择的等级
    editPrivate() {
      const that = this
      apiFetchIncomeGradeList().then((res) => {
        if (res) {
          this.defaultIndex = res.incomeGrade
          res.gradeIncomeCfg.forEach((item) => {
            // 先取一个income
            if (item.grade == res.incomeGrade) {
              this.myPrivateCallIncome = item.incomePerMinute
              this.$emit('hostessIncome', this.myPrivateCallIncome)
            }
            // 处理数据
            const url1 = that.getMatchImg('beans')
            const url2 = that.getMatchImg('beans-off')
            const url3 = require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/black_unlock.png')
            item['img1'] = `<img src=${url1} width="24" height="20" style="position:relative;top:3px;padding:0 2px">`
            item['img2'] = `<img src=${url2} width="24" height="20" style="position:relative;top:3px;padding:0 2px">`
            item['img3'] = `<img src=${url3} width="18"  style="position:relative;top:2px;padding:0 2px">`

            const option = {}
            option['id'] = item.grade
            if (item.grade > res.curGrade) {
              option['text'] = item.incomePerMinute + item.img2 + '/min(' + this.$t('lang.BaseCommon.k002') + '.' + item.grade + ')' + item.img3
            } else {
              option['text'] = item.incomePerMinute + item.img1 + '/min(' + this.$t('lang.BaseCommon.k002') + '.' + item.grade + ')'
            }
            this.gradeOptions.push(option)
          })

          this.gradeIncomeInfo = res
        }
      })
    },

    fetchChoosePrivilege(grade, text) {
      apiFetchChoosePrivilege(grade).then((res) => {
        if (res.status == 200) {
          this.showPri = false
          this.myPrivateCallIncome = text.substring(0, text.indexOf('<img'))
        }
      })
    },

    // 特权图标背景色会根据等级变化（map 存各特权首次解锁的 grade）
    getPrivilegeColors(stepCurLevel, item) {
      const unlockGrade = this.map.get(String(item.privilegeType))
      if (unlockGrade == null) {
        return 'linear-gradient(90deg, #ececec 0%, #d9d9d9 100%)'
      }
      if (stepCurLevel < unlockGrade) {
        return 'linear-gradient(90deg, #ececec 0%, #d9d9d9 100%)'
      }
      if (stepCurLevel < 1 && unlockGrade < 1) {
        return 'linear-gradient(90deg, #C3A4F8 0%, #CB83F2 100%)'
      }
      if (stepCurLevel <= 3 && unlockGrade < 3) {
        return 'linear-gradient(90deg, #B9D8F6 0%, #A3B1FB 100%)'
      }
      if (stepCurLevel <= 6 && unlockGrade < 6) {
        return 'linear-gradient(90deg, #C3A4F8 0%, #CB83F2 100%)'
      }
      if (stepCurLevel <= 10 && unlockGrade < 10) {
        return 'linear-gradient(90deg, #FFCAC2 0%, #FDA0AA 100%)'
      }
      return 'linear-gradient(90deg, #FFCAC2 0%, #FDA0AA 100%)'
    },
  },
  created() {
    this.fetchHostGradeInfo()
    this.editPrivate()
  },
}
</script>

<style lang="less" scoped>
.my-level {
  .level-bg-box {
    position: relative;
    width: 327px;
    min-height: 157px;
    margin: 20px auto 0;
    padding: 32px 20px 10px;
  }
  .level-bg {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-position: left top;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-color: #eaeaea;
    border-radius: 19px;
  }
  .level-box {
    position: relative;
    z-index: 10;
    width: 100%;
    .level-img {
      width: 110px;
      height: 110px;
      background: url('~@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_off.png') no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: -45px;
      right: -20px;
      font-family: 'Inter-Regular';
      font-weight: bold;
      font-size: 30px;
      color: #ffffff;
      line-height: 110px;
      text-align: center;
    }
    .level-text {
      width: 75px;
      height: 44px;
      font-family: 'Inter-Regular';
      font-weight: 500;
      font-size: 36px;
      color: #3c2913;
      line-height: 44px;
    }
    .progress-box {
      width: 100%;
      margin-top: 25px;
      font-family: 'Inter-Regular';
      font-weight: 500;
      font-size: 11px;
      color: #947641;
      .beans {
        display: block;
        display: flex;
        align-items: center;
        .beans-img {
          margin: 0 2px;
        }
      }
      .beans-img {
        width: 11px;
        height: 11px;
      }
      .beans-tip {
        display: block;
        text-align: center;
        padding: 0 5px;
        > img {
          position: relative;
          top: -1px;
          vertical-align: middle;
        }
      }
      .get-bean {
        margin: 0 3px;
      }
      .text {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
      }
      .progress-line {
        position: relative;
        width: 100%;
        height: 8px !important;
        margin: 4px auto 6px;
        .progress-bar {
          height: 8px !important;
          border-radius: 20px;
          ::v-deep .van-progress__portion {
            background: linear-gradient(90deg, #e2cca6 0%, #b29360 100%) !important;
          }
        }
      }
    }
  }
  .call-income {
    width: 327px;
    height: 56px;
    padding: 17px 12px 0;
    margin: -17px auto 0;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: 'Inter-Regular';
    border-radius: 0 0 10px 10px;
    .title {
      color: #333333;
    }
    .income {
      display: flex;
      align-items: center;
      color: var(--theme-call-income-accent, #925dff);
      .income-num-img {
        display: flex;
        align-items: center;
        margin: 0 5px;
        > img {
          width: var(--theme-income-bean-img-w, 11px);
          margin: 0 1px;
        }
      }
      .edit {
        font-size: 16px;
      }
    }
  }
  .week-data {
    position: relative;
    width: 327px;
    margin: 10px auto 30px;
    padding: 10px 0;
    background: #ffffff;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    .week {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 20px;
      width: 36px;
      font-family: 'Inter-Regular';
      font-weight: 400;
      font-size: 17px;
      color: #3c2913;
      .beans {
        display: flex;
        align-items: center;
        margin: 4px 0 6px 0;
        > img {
          width: 16px;
          height: 16px;
          margin: 0 1px;
        }
      }
      > span:nth-child(3) {
        color: var(--theme-week-muted, #999999);
        font-weight: 400;
        font-size: 12px;
        text-align: center;
      }
    }
    .line {
      height: 36px;
      width: 1px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateY(-50%);
      background: #f0f0f0;
    }
  }
  .content {
    width: 100%;
    font-family: 'Inter-Regular';
    padding: 0 16px;
    .box-title {
      margin: 30px 8px 16px;
      font-weight: 600;
      color: #333333;
      line-height: 26px;
      font-size: 14px;
    }
    .level-number {
      width: 328px;
      height: 24px;
      margin: 16px auto 10px;
      overflow-x: auto;
      white-space: nowrap;
      > div {
        display: inline-block;
        height: 20px;
        padding: 0 5px;
        font-weight: 400;
        font-size: 14px;
        color: var(--theme-level-num-inactive, #999999);
        line-height: 20px;
        text-align: center;
      }
      scrollbar-width: none;
      -ms-overflow-style: none;
      .active {
        position: relative;
        color: var(--theme-level-tab-active, #925dff);
        font-weight: 600;
        font-size: 17px;
      }
      .active::after {
        content: '';
        display: block;
        position: absolute;
        bottom: -4px;
        left: 50%;
        transform: translateX(-50%);
        width: 27px;
        height: 2px;
        background-color: var(--theme-level-tab-underline, #d7c7fc);
        border-radius: 2px;
      }
    }
    .level-right-box {
      width: 343px;
      min-height: 92px;
      padding: 10px;
      margin: 0 auto;
      background: #ffffff;
      border-radius: 12px;
    }
    .level-right {
      font-family: 'Inter-Regular';
      display: flex;
      justify-content: space-between;
      padding: 16px 0;
      border-bottom: 1px solid #f9f9fb;
      .right-item {
        display: flex;
      }
      .right-img {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border: 1px solid #ffffff;
        border-radius: 50%;
        > img {
          width: 24px;
          height: 24px;
        }
      }
      .right-text {
        width: 176px;
        margin: 0 8px;
        .tit {
          // height: 17px;
          margin-bottom: 8px;
          font-size: 14px;
          line-height: 17px;
          color: #333333;
          font-weight: 500;
        }
        .con {
          line-height: 15px;
          font-size: 12px;
          color: var(--theme-right-text-muted, #999999);
          font-weight: 400;
          white-space: wrap;
        }
      }
      .right-desc {
        display: flex;
        font-weight: 500;
        font-size: 14px;
        color: var(--theme-right-desc-accent, #925dff);
        line-height: 17px;
        text-align: center;
        font-style: normal;
        .right-desc-val {
          display: flex;
          align-items: center;
          .icon {
            width: 14px;
            margin: 0 1px;
          }
        }
        .icon {
          width: var(--theme-right-desc-icon-w, 18px);
        }
        .icon2 {
          width: 12px;
          margin: 0 3px;
        }
      }
    }
    .level-right:last-child {
      border-bottom: none;
    }

    // 规则
    .rule-tit {
      width: 343px;
      padding: 8px 12px;
      margin: 0 auto;
      background: #ededf3;
      border-radius: 6px;
      font-weight: 400;
      font-size: 11px;
      color: #333333;
      line-height: 18px;
    }
    .table-box {
      margin: 0 auto;
      margin-top: 10px;
      font-family: 'Inter-Regular';
      font-size: 14px;
      border-radius: 2px;
      .header {
        font-size: 15px;
        color: #333333;
      }
      th {
        height: 36px;
        font-weight: 700;
        text-align: center;
        border: 1px solid #e9e9e9;
        background-color: #f1f1f6;
      }
      td {
        height: 36px;
        text-align: center;
        border: 1px solid #e9e9e9;
        > img {
          width: 16px;
        }
      }
      td:nth-child(1) {
        width: 114px;
        color: var(--theme-table-td-muted, #999999);
      }
      td:nth-child(2) {
        width: 230px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 14px;
          margin: 0 2px;
        }
      }
      .td-item {
        background-color: #fff;
      }
      .td-item:nth-child(odd) {
        background-color: #fafbfd;
      }
    }
  }
  .wrapper {
    display: flex;
    justify-content: center;
    width: 315px;
    height: 312px;
    padding: 20px 20px 10px;
    background-color: #fff;
    border-radius: 20px;
    font-family: 'Inter-Regular';
    text-align: center;
    .wrapper-title {
      margin: 20px 0 12px;
      text-align: center;
      font-weight: 600;
      font-size: 17px;
      color: #333333;
    }
    .wrapper-content {
      display: inline-block;
      font-size: 15px;
      color: var(--theme-wrapper-muted, #999999);
      line-height: 22px;
      text-align: left;
    }
    ::v-deep .van-swipe__indicator--active {
      background-color: var(--theme-swipe-indicator-active, #a338fc) !important;
    }
  }

  .van-swipe-item {
    width: 275px !important;
    height: 160px !important;

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .my-level .level-bg-box .level-bg {
    transform: rotateY(180deg) !important;
  }

  .my-level .level-bg-box .level-img {
    right: auto !important;
    left: -20px !important;
  }
}
</style>
